import {
  LayoutListDefinition,
  LAYOUT_LIST,
  QUESTION_BRANCHING,
  QUIZ_CHOICE,
  QuestionBranchingDefinition
} from '../items';
import { Translator } from '../Translator';
import { AnswerButtonHelper } from './itemHelpers/AnswerButtonHelpers';
import { CardHelper } from './itemHelpers/CardHelper';
import { TextHelper } from './itemHelpers/TextHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';

export const Cards61: Translator = sequence => {
  const cardsList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.cardlist`,
    values: {
      orientation: 'row',
      align: 'center',
      padded: true
    },
    items: [
      {
        id: `${sequence.id}.questionsequence`,
        type: QUESTION_BRANCHING,
        values: void {},
        items: []
      } as QuestionBranchingDefinition
    ]
  } as LayoutListDefinition;

  const mainList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.list`,
    values: {
      orientation: 'column',
      align: 'center',
      padded: true
    },
    items: []
  } as LayoutListDefinition;

  const root = translate(sequence, item => {
    if (item.__typename === 'Question') {
      cardsList.items[0].items.push(
        CardHelper(item as ItemOfType<'Question'>, {
          height: 'unset',
          width: '300px',
          padding: '0px',
          extraItems: [
            {
              id: `${item.id}.quiz`,
              type: QUIZ_CHOICE,
              values: {},
              items: AnswerButtonHelper(
                item.id,
                item.items,
                item.audios?.[0]?.id,
                item.llamaSurvey,
                item.title || ''
              )
            }
          ]
        })
      );
    } else if (item.__typename === 'Card') {
      cardsList.items[0].items.push(
        CardHelper(item as ItemOfType<'Card'>, {
          height: 'unset',
          width: '269px',
          padding: '0px'
        })
      );
    } else if (item.__typename === 'Text') {
      mainList.items = [
        {
          type: LAYOUT_LIST,
          id: `${sequence.id}.list`,
          values: {
            orientation: 'column',
            align: 'top',
            padded: true
          },
          items: TextHelper(item as ItemOfType<'Text'>)
        } as LayoutListDefinition
      ];
    }

    return null;
  });

  mainList.items.push(cardsList);
  if (mainList.items.length > 1) {
    // adding a dummy item for spacing... bit hackish but ok
    mainList.items.push({
      type: LAYOUT_LIST,
      id: `${sequence.id}.blank`
    } as LayoutListDefinition);
  }
  root.items.push(mainList);

  return root;
};
